import { faCircleCheck } from "@fortawesome/pro-light-svg-icons";
import { faCircleCheck as faCircleCheckFilled } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { clsx } from "clsx/lite";

type PasswordRequirementItemProps = {
  isSatisfied: boolean;
  children: ReactNode;
};

export function PasswordRequirementItem({
  isSatisfied,
  children,
}: PasswordRequirementItemProps) {
  return (
    <div
      className={clsx(
        "flex",
        "flex-row",
        "gap-1",
        "items-center",
        "text-font-secondary",
        isSatisfied && "line-through text-green-500",
      )}
    >
      <FontAwesomeIcon
        icon={isSatisfied ? faCircleCheckFilled : faCircleCheck}
        className={clsx(isSatisfied ? "text-green-500" : "text-font-secondary")}
      />
      {children}
    </div>
  );
}
